"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TwoToneDomain;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _plus = _interopRequireDefault(require("@ux/icon/plus"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function TwoToneDomain(params) {
  const {
    names = [],
    extensions = [],
    extensionColorClassName = 'text-primary',
    textClassName = '',
    isDesktop = false,
    tagIcon,
    customColor
  } = params;
  const fontSize = names.some(name => name.length > 12) || !isDesktop ? 'two-tone-domain-mobile' : 'ms9';
  const isAnyDomainLongerThan25Chars = names.some(name => name.length > 25);
  const areAllDomainsLongerThan25Chars = names.reduce((length, name) => {
    length += name.length;
    return length;
  }, 0) > 25;
  const multiLinedomainList = names?.map((name, index) => {
    const tld = extensions[index];
    return /*#__PURE__*/_react.default.createElement("li", {
      key: name + tld,
      className: (0, _classnames.default)(`mb-n1`, {
        'mt-n1': index !== 0
      })
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "d-inline-block"
    }, name, tld && /*#__PURE__*/_react.default.createElement("span", {
      className: "d-inline-block text-primary",
      "data-cy": "two-tone-domain-multi-tld",
      "data-testid": "two-tone-domain-multi-tld"
    }, `.${tld}`)));
  });
  const multiLineDisplay = /*#__PURE__*/_react.default.createElement("ul", {
    "data-cy": "multi-line-display",
    "data-testid": "multi-line-display",
    className: (0, _classnames.default)('list-unstyled font-weight-bold my-1 lh-reset', {
      'd-inline-block mr-1': Boolean(tagIcon)
    })
  }, multiLinedomainList);
  const extensionStyle = customColor ? {
    color: customColor
  } : null;
  const singleLineDisplay = /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "single-line-display",
    "data-testid": "single-line-display",
    className: (0, _classnames.default)('lh-reset', {
      'd-inline-block mr-1': Boolean(tagIcon)
    })
  }, names.map((name, index) => {
    const tld = extensions[index];
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: `${name}-${index}`
    }, index === 1 ? /*#__PURE__*/_react.default.createElement("div", {
      className: "mx-1",
      style: {
        display: 'inline-block'
      }
    }, /*#__PURE__*/_react.default.createElement(_plus.default, {
      height: 16,
      width: 16,
      color: "black"
    })) : null, name === names[index - 1] ? null : name, tld && /*#__PURE__*/_react.default.createElement("span", {
      "data-cy": "two-tone-domain-single",
      "data-testid": "two-tone-domain-single",
      className: `d-inline-block ${extensionColorClassName}`,
      style: extensionStyle
    }, `.${tld}`));
  }));
  const namesAndExtensions = areAllDomainsLongerThan25Chars || isAnyDomainLongerThan25Chars ? multiLineDisplay : singleLineDisplay;
  const textClassnames = textClassName || (0, _classnames.default)('font-weight-semibold', {
    'mb-1': isDesktop,
    'mb-0': !isDesktop
  });
  return /*#__PURE__*/_react.default.createElement("p", {
    role: "heading",
    "aria-level": "2",
    "data-cy": "two-tone-domain",
    "data-testid": "two-tone-domain",
    dir: "ltr",
    className: `d-inline-block break-text-anywhere ${fontSize} ${textClassnames}`
  }, namesAndExtensions, tagIcon);
}
TwoToneDomain.propTypes = {
  textClassName: _propTypes.default.string,
  names: _propTypes.default.array.isRequired,
  extensions: _propTypes.default.array.isRequired,
  extensionColorClassName: _propTypes.default.string,
  fontSizeClassName: _propTypes.default.string,
  isDesktop: _propTypes.default.bool,
  tagIcon: _propTypes.default.node,
  customColor: _propTypes.default.string
};